import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
	selector: 'app-daily-usage-metrics',
	templateUrl: './daily-usage-metrics.component.html',
	styleUrls: ['./daily-usage-metrics.component.css']
})
export class DailyUsageMetricsComponent {
	@Input() data!: any;
	@Input() selectedDays!: any;


	cards: any[] = [];
	showData: boolean = true;

	ngOnChanges(changes: SimpleChanges) {
		if (!this.data)
			return this.showData = false;

		if(this.data && Object.keys(this.data).length || changes['selectedDays']) {
			this.buildCards();
		}
	}

	buildCards() {
		let selectedData = this.data?.[this.selectedDays];
		this.showData = true;
		

		if (!selectedData || (!selectedData.avgDailyUsage?.length && !selectedData.avgDailyUbuAh?.length)) {
			this.showData = false;
			return;
		}

		const avgDailyUsage = selectedData.avgDailyUsage[0];
		/********************************daily hours summary*****************************/
		const avgInUse = avgDailyUsage.inuse_time / avgDailyUsage.total_days_in_period;
		const avgOffIdle = avgDailyUsage.idle_off_time / avgDailyUsage.total_days_in_period;
		const avgCharge = avgDailyUsage.charge_time / avgDailyUsage.total_days_in_period;


		const inUsePercent = (avgInUse * 100) / 24;
		const idleOffPercent = (avgOffIdle * 100) / 24;
		const chargePercent = (avgCharge * 100) / 24;

		const maxInuseTime = avgDailyUsage.max_inuse_time;
		const minIdleOffTime = avgDailyUsage.min_idle_off_time;
		const minChargeTime = avgDailyUsage.min_charge_time;

		const maxInuseTimePercent = (maxInuseTime * 100) / 24;
		const minIdleOffTimePercent = (minIdleOffTime * 100) / 24;
		const minChargeTimePercent = (minChargeTime * 100) / 24;


		const avgCard = {
			title: 'Daily Hours Summary',
			class: 'card-blue',
			icon: 'fa fa-clock-o',
			iconClass: 'icon-blue',
			rows: [
				this.buildRow('Average In-Use Hours', avgInUse, inUsePercent, 'bg-deep-orange', { isHour: true }),
				this.buildRow('Max In-Use Hours', maxInuseTime, maxInuseTimePercent, 'bg-red', { isHour: true }),

				this.buildRow('Average Charge Hours', avgCharge, chargePercent, 'bg-green', { isHour: true }),
				this.buildRow('Min Charge Hours', minChargeTime, minChargeTimePercent, 'bg-green', { isHour: true }),

				this.buildRow('Average Off/Idle Hours', avgOffIdle, idleOffPercent, 'bg-gray', { isHour: true }),
				this.buildRow('Min Idle/Off Hours', minIdleOffTime, minIdleOffTimePercent, 'bg-gray', { isHour: true }),

			]
		};
		/********************************daily hours summary*****************************/


		/********************************daily UBU/Ah summary*****************************/
		const avgDailyUbuAh = selectedData.avgDailyUbuAh[0];

		const ubuCard = {
			title: 'Daily UBU/Ah Summary',
			class: 'card-green',
			icon: 'fa fa-line-chart',
			iconClass: 'icon-blue',
			rows: [
				this.buildRow('Average In-Use UBU', avgDailyUbuAh.avgInUseUbu, avgDailyUbuAh.avgInUseUbu, 'bg-deep-orange', {
					percentAsRatio: true,
					showPercent: false,
					fixedDecimals: 2
				}),
				this.buildRow('Max In-Use UBU', avgDailyUbuAh.maxInuseUbu, avgDailyUbuAh.maxInuseUbu, 'bg-red', {
					percentAsRatio: true,
					showPercent: false,
					fixedDecimals: 2
				}),

				this.buildRow('Average In-Use Ah/hr', avgDailyUbuAh.avgInuseAhr, (avgDailyUbuAh.avgInuseAhr / avgDailyUbuAh.maxInuseAhr) * 100, 'bg-green', {
					showPercent: false,
					fixedDecimals: 2
				}),
				this.buildRow('Max In-Use Ah/hr', avgDailyUbuAh.maxInuseAhr, avgDailyUbuAh.maxInuseAhr, 'bg-green', {
					showPercent: false,
					fixedDecimals: 2
				}),

				this.buildRow('Average Charge Ah', avgDailyUbuAh.avgChargeAhr, (avgDailyUbuAh.avgChargeAhr / avgDailyUbuAh.maxChargeAhr) * 100, 'bg-gray', {
					showPercent: false,
					fixedDecimals: 2
				}),
				this.buildRow('Min Charge Ah', avgDailyUbuAh.minChargeAhr, (avgDailyUbuAh.minChargeAhr / avgDailyUbuAh.maxChargeAhr) * 100, 'bg-gray', {
					showPercent: false,
					fixedDecimals: 2
				}),
			]
		};
		/********************************daily UBU/Ah summary*****************************/

		this.cards = [avgCard, ubuCard];
	}

	buildRow(label: string, value: number, percent: number, color: string, options: { isHour?: boolean; showPercent?: boolean; percentAsRatio?: boolean; fixedDecimals?: number; } = {}) {
		const { isHour = false, showPercent = true, percentAsRatio = false, fixedDecimals = 1 } = options;

		let safePercent = !isFinite(percent) || isNaN(percent) ? 0 : percent;
		safePercent = Math.max(0, safePercent);

		let safeValue = !isFinite(value) || isNaN(value) ? 0 : value;
		safeValue = Math.max(0, safeValue);

		let formattedValue;
		if (isHour) {
			safeValue = Math.min(24, safeValue);
			formattedValue = safeValue.toFixed(1);
		} else {
			formattedValue = safeValue.toFixed(fixedDecimals);
		}

		let formattedPercent = safePercent;
		if (percentAsRatio) {
			formattedPercent = safePercent * 100;
		}

		formattedPercent = Math.min(100, Math.max(0, formattedPercent));

		return {
			label,
			value: formattedValue,
			percent: formattedPercent.toFixed(1),
			color,
			isHour,
			showPercent
		};
	}
}
